(function ($, Drupal) {

  // To understand behaviors, see https://drupal.org/node/756722#behaviors
  Drupal.behaviors.essentSearch = {
    attach: function (context) {
      const $searchbox = $('.search-block-form', context);

      if ($searchbox.length === 0) {
        return;
      }

      if ($(window).width() >= 768) {

        $('.search-toggle').on('click.toggleSearchBoxOpen', function() {
          $(this).closest($searchbox).toggleClass('open');
        });

      }
      else {

        $('.nav-search-toggle').on('click.toggleSearchBoxOpenMobile', function() {
          $(this).toggleClass('open');
          $(this).siblings('.nav-mobile-toggle').toggleClass('hidden');
          $('.region-header').find($searchbox).toggleClass('open');
        });

        $('.search-toggle').on('click.toggleSearchSubmit', function() {
          $(this).siblings('form').submit();
        });
      }

      $( window ).on('resize.removeClassesDesktop',function() {
        if ($(window).width() >= 768) {
          $('.nav-search-toggle').removeClass('hidden');
          $('.region-header .search-block-form').removeClass('open');
        }
      });

    }
  };
}(jQuery, Drupal));